import React, { useState } from "react";
import img from "../Images/wholesale.jpg";

const Wholesale = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [subject, setSubject] = useState("");
  const [number, setNumber] = useState("");
  const [company, setCompany] = useState("");
  const [District, setDistrict] = useState("");
  const [businessAddress, setBusinessAddress] = useState("");
  const [message, setMessage] = useState("");

  const recipientEmail = "enamul.sajeeb@gmail.com";
  const emailSubject = "";
  const emailBody = "";

  const mailtoLink = `mailto:${recipientEmail}?subject=${emailSubject}&body=${emailBody}`;

  return (
    <div className="sm:p-16 flex gap-10 flex-col lg:flex-row">
      <div className="p-4 sm:p-10 flex flex-col gap-4 w-[100%] lg:w-[50%]">
        <div>
          <p>Your name</p>
          <input
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="border border-secondary px-4 py-2 w-[100%] border-opacity-30 rounded"
            type="text"
            placeholder="Your name"
          />
        </div>
        <div>
          <p>Your email</p>
          <input
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="border border-secondary px-4 py-2 w-[100%] border-opacity-30 rounded"
            type="email"
            placeholder="Your email"
          />
        </div>
        <div>
          <p>Subject</p>
          <input
            value={subject}
            onChange={(e) => setSubject(e.target.value)}
            className="border border-secondary px-4 py-2 w-[100%] border-opacity-30 rounded"
            type="text"
            placeholder="Subject"
          />
        </div>
        <div>
          <p>Contact number</p>
          <input
            value={number}
            onChange={(e) => setNumber(e.target.value)}
            className="border border-secondary px-4 py-2 w-[100%] border-opacity-30 rounded"
            type="number"
            placeholder="Your contact number"
          />
        </div>
        <div>
          <p>Company name </p>
          <input
            value={company}
            onChange={(e) => setCompany(e.target.value)}
            className="border border-secondary px-4 py-2 w-[100%] border-opacity-30 rounded"
            type="text"
            placeholder="Company name"
          />
        </div>
        <div>
          <p>Your District</p>
          <input
            value={District}
            onChange={(e) => setDistrict(e.target.value)}
            className="border border-secondary px-4 py-2 w-[100%] border-opacity-30 rounded"
            type="text"
            placeholder="Your district"
          />
        </div>
        <div>
          <p>Business address</p>
          <input
            value={businessAddress}
            onChange={(e) => setBusinessAddress(e.target.value)}
            className="border border-secondary px-4 py-2 w-[100%] border-opacity-30 rounded"
            type="text"
            placeholder="Business address"
          />
        </div>
        <div>
          <p>Your message (optional)</p>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows={6}
            className="border border-secondary px-4 py-2 w-[100%] border-opacity-30 rounded"
            type="text"
            placeholder="Your message"
          />
        </div>

        <a
          className="bg-secondary text-center px-10 py-3 text-primary rounded hover:bg-accent ease-in-out duration-200"
          href={mailtoLink}
        >
          Submit
        </a>
      </div>
      <div className="w-[100%] lg:w-[50%] mt-6">
        <img src={img} alt="" />
      </div>
    </div>
  );
};

export default Wholesale;
